<template>
  <v-layout row wrap>
    <v-flex sm12 md12 class="px-5 pb-4 tabulardata">
      <v-text-field
        class="search-input"
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-flex> 
    
      <v-flex sm12 md12>
        <div class="text-center mb-4">
          <v-pagination :total-visible="10" :circle="true"  v-model="page" :length="pageCount"></v-pagination>
        </div>
        <v-data-table
          :headers="headers"
          :items="roles"
          :search="search"
          class="px-5 pb-4 tabulardata"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          hide-default-footer
          @page-count="pageCount = $event"
        >
        <template v-slot:body="{ items }">
          <tbody>
            <tr v-for="(item,index) in items" :key="'role-list' + index">
              <td class="text-left">{{ item.name }}</td>
              <td class="text-left">{{item.desc }}</td>
              <td class="text-left">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      depressed
                      @click="editPermission(item)"
                      fab 
                      dark 
                      small
                      color="primary"
                      v-on="on"
                      :class="'mr-2'"
                    >
                      <v-icon dark>edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit Role Permissions</span>
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      depressed
                      @click="deleteItem(item)"
                      fab 
                      dark 
                      small
                      color="primary"
                      v-on="on"
                      :class="'mr-2'"
                    >
                      <v-icon dark>delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Delete Role</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </template>
        <template v-slot:no-data>
          <p class="text-xs-center mb-0">You have not yet created any roles. You can create your first role by clicking the + button</p>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import Env from '@/env';
import AuthApi from '@/components/Controllers/AuthApis';
import Helper from '@/components/Controllers/Helpers';
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      search: '',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      headers: [
        { text: 'Name', value: 'name', sortable: true, class: 'font-weight-bold' },
        { text: 'Description', value: 'description', sortable: true, class: 'font-weight-bold' },
        { text: 'Action', value: '', sortable: false, class: 'font-weight-bold' },
      ],
    };
  },
  computed: {
    ...mapGetters({
      roles: 'role/list',
    }),
    
  },
  created() {
    this.fetchRoles();
  },
  methods: {
    /**
    *  Fetch all business roles
    */
    fetchRoles() {  
      const url = `${Env.url}/api/v1/roles`;
      AuthApi.getApi(url)
      .then((res) => {
        this.setList(res.data.payload);
      })
      .catch((err) => {
        console.log('Unable to fetch roles');
      });
    },
    /**
     * To edit role's  permission
     * @function
     * @return null
     */
    editPermission(obj) {
      this.setEditPermission(true);
      this.setEditPermissionObj(obj);
    },

    /**
     *  Delete role
     */
    deleteItem(obj) {
      this.setDeletePop(true);
      this.setDeleteObj(obj);
    },

    ...mapActions({
      setEditPermission: 'role/setEditPermission',
      setEditPermissionObj: 'role/setEditPermissionObj',
      setDeletePop: 'role/setDelete',
      setDeleteObj: 'role/setDeleteObj',
      setList: 'role/setList',
    }),
  },
};
</script>
